<div
    class="mat-step-header-ripple"
    matRipple
    [matRippleTrigger]="_getHostElement()"
    [matRippleDisabled]="disableRipple"
></div>

<div class="mat-step-icon-state-{{state}} mat-step-icon" [class.mat-step-icon-selected]="selected">
    <div class="mat-step-icon-content" [ngSwitch]="!!(iconOverrides && iconOverrides[state])">
        <ng-container
            *ngSwitchCase="true"
            [ngTemplateOutlet]="iconOverrides[state]"
            [ngTemplateOutletContext]="_getIconContext()"
        ></ng-container>
        <ng-container *ngSwitchDefault [ngSwitch]="state">
            <span *ngSwitchCase="'number'" class="number-step-number">{{_getDefaultTextForState(state)}}</span>
            <span *ngSwitchCase="'edit'" class="edit-step-number">{{_getDefaultTextForState('number')}}</span>
            <span *ngSwitchCase="'done'" class="done-step-number">{{_getDefaultTextForState('number')}}</span>
            <!-- TODO I left this to be replaced with the check mark instead in case of done state -->
            <!-- <mat-icon *ngSwitchDefault>{{_getDefaultTextForState(state)}}</mat-icon> -->
        </ng-container>
    </div>
</div>

<div class="circular-progress" *ngIf="state === 'edit'">
    <mat-progress-spinner
        [diameter]="33"
        class="custom-spinner"
        class="example-margin"
        [color]="'#3C8ED3'"
        strokeWidth="2"
        [mode]="mode"
        [value]="_circularPercentage"
    >
    </mat-progress-spinner>
</div>
<div class="mat-step-label mat-step-text-label">
    <!-- If there is a label template, use it. -->
    <div [ngClass]="{'edit-text-label': selected, 'done-text-label': state == 'done'}">
        <ng-container *ngIf="_templateLabel()" [ngTemplateOutlet]="_templateLabel()!.template"> </ng-container>
    </div>

    <!-- If there is no label template, fall back to the text label. -->
    <div class="mat-step-text-label" *ngIf="_stringLabel()" [ngSwitch]="state">
        <span *ngSwitchCase="'edit'" class="edit-text-label">{{label}}</span>
        <span *ngSwitchCase="'done'" class="done-text-label">{{label}}</span>
        <span *ngSwitchDefault>{{label}}</span>
    </div>

    <div class="mat-step-optional" *ngIf="optional && state != 'error'">{{_intl.optionalLabel}}</div>
    <div class="mat-step-sub-label-error" *ngIf="state == 'error'">{{errorMessage}}</div>
</div>
